module.exports = __webpack_public_path__ + "media/dau_2.bf71068f.mp3";